import { render, staticRenderFns } from "./DurationExpression.vue?vue&type=template&id=f35728f4&"
import script from "./DurationExpression.vue?vue&type=script&lang=js&"
export * from "./DurationExpression.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports